import React, { useState } from 'react';
import './UXScoreContent.css';
import UXMetricCard from './UXMetricCard/UXMetricCard';
import ReadabilitySection from './ReadabilitySection/ReadabilitySection';
import StructureSection from './StructureSection/StructureSection';
import ScoreDisplay from '../ScoreProgressBar/ScoreDisplay';
import { useTranslation } from 'react-i18next';

const UXScoreContent = ({ scoreData, wordCount }) => {
  const data = scoreData;
  const { t } = useTranslation();
  if (!data || !data.metrics) {
    return null;
  }

 
  const readabilityScore = data.metrics.readability?.score?.score || 0;
  const structureScore = data.metrics.structure?.score || 0;
  const structureTitle = data.metrics.structure?.title || 'Structure';

  return (
    <>
      <ScoreDisplay score={data.uxScore} />
      <div className="metric-cards-container">
        {/* Readability Card */}
        <UXMetricCard
          title={t('Lisibilité')}
          score={readabilityScore}
          infoTooltip="scoreTooltip.readability"
        >
          <ReadabilitySection data={data.metrics.readability} />
        </UXMetricCard>

        {/* Structure Card */}
        <UXMetricCard
          title={`${structureTitle} :`}
          score={structureScore}
          infoTooltip="scoreTooltip.structure"
        >
          <StructureSection
            data={data.metrics.structure}
            wordCount={wordCount}
          />
        </UXMetricCard>
      </div>
    </>
  );
};

export default UXScoreContent;
